import {Api} from '../../Api.js'

const RESOURCE = 'scope'

export default {
    resource: RESOURCE,
    query(query) {
        return Api().get(this.resource + (query ? query : ''))
    },
    get(id) {
        return Api().get(this.resource + '/' + id)
    },
    create(data) {
        return Api().post(this.resource, data)
    },
    update(id, data) {
        return Api().put(this.resource + '/' + id, data)
    },
    validateAddress(data) {
        return Api().post('geolocation/validate', data)
    },
    delete(id) {
        return Api().delete(this.resource + '/' + id)
    },
    getCurrencyConversion(id) {
        return Api().get(this.resource + '/currency-conversion/' + id)
    },
    getGoalCompletions(query) {
        return Api().get(this.resource + '/goals')
    },
    getNotificationSent(period, provider) {
        return Api().get(this.resource + '/stats/notification?period=' + period + "&provider=" + provider )
    },
     getTranslation(label, source, target) {
        if (target === 'en') {
            target = 'en-US'
        }
        return Api().post('/translate', {
            message: label,
            source: source,
            target: target
        })
    },
    getGoogleTaxonomies() {
        return Api().get('google/taxonomy')
    },
}


// WEBPACK FOOTER //
// ./src/modules/scope/ScopeService.js